import AlunosIndexPage from "@/Pages/Alunos/index.vue";
import NewEditAlunoPage from "@/Pages/Alunos/NewEditAlunoPage.vue";
import AlunosPesquisaAvancada from "@/Pages/Alunos/AlunosPesquisaAvancada.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/alunos/",
    name: "alunos",
    component: AlunosIndexPage,
    beforeEnter: checkPermission(["alunos.criarAluno", "alunos.*"]),
  },
  {
    path: "/alunos/pesquisa-avancada",
    name: "alunos-pesquisa-avancada",
    component: AlunosPesquisaAvancada,
    beforeEnter: checkPermission(["alunos.criarAluno", "alunos.*"]),
  },
  {
    path: "/alunos/create",
    name: "alunos.create",
    component: NewEditAlunoPage,
    props: { editing: false },
  },
  {
    path: "/alunos/edit/:aluno_id",
    name: "alunos.edit",
    component: NewEditAlunoPage,
    props: { editing: true },
  },
];
